var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.652,
    height: 21.821,
    viewBox: "0 0 24.652 21.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126",
    transform: "translate(1 -7.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4122",
    "data-name": "Group 4122",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-svgrepo-com_2_",
    "data-name": "chat-svgrepo-com (2)",
    transform: "translate(0 7.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4117",
    "data-name": "Group 4117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M16.517,32H6.135A6.142,6.142,0,0,0,0,38.135V41.91a6.142,6.142,0,0,0,6.135,6.135H7.551v3.3a.472.472,0,0,0,.292.436.462.462,0,0,0,.18.036.476.476,0,0,0,.334-.138l3.637-3.638h4.524a6.142,6.142,0,0,0,6.135-6.135V38.135A6.142,6.142,0,0,0,16.517,32Z",
    transform: "translate(0 -32)",
    fill: "none",
    stroke: "#403e5c",
    strokeWidth: 2
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.c158fdd4a66fad8918b75d962bb9832e.svg";
export { ForwardRef as ReactComponent };